import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";
import "./ForgotPassword.css";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const res = await api.post("/api/auth/forgot-password", { email });
      const { tempPassword, message } = res.data;

      // Save data to localStorage for the NEXT PAGE to read
      if (tempPassword) {
        localStorage.setItem("auth_tempEmail", email);
        localStorage.setItem("auth_tempPassword", tempPassword);
        localStorage.removeItem("auth_tempPasswordExpiry"); // Just in case
        
        setStatus({ type: "success", message: "Password Generated!" });
        
        // Small delay to let user see the success message before redirecting
        setTimeout(() => {
          navigate("/reset-password");
        }, 1500);
      } else {
        setStatus({ type: "error", message: "Unable to generate password." });
      }

    } catch (err) {
      setStatus({ type: "error", message: err.response?.data?.message || "Operation failed" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fp-container">
      <div className="fp-card">
        <h2>Request Password Reset</h2>
        <form onSubmit={handleSubmit} className="fp-form">
          <input
            type="email"
            placeholder="Enter Registered Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="fp-input"
          />
          <button type="submit" disabled={isLoading} className={`fp-btn ${isLoading ? 'loading' : ''}`}>
            {isLoading ? "Generating..." : "Generate Temporary Password"}
          </button>
        </form>
        {status.message && <div className={`fp-msg ${status.type}`}>{status.message}</div>}
        
        <div className="fp-links">
          <Link to="/login">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}